import { render, staticRenderFns } from "./jixiao.vue?vue&type=template&id=c1c477ba"
import script from "./jixiao.vue?vue&type=script&lang=js"
export * from "./jixiao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports